import { render, staticRenderFns } from "./ServicesPricing.vue?vue&type=template&id=676f8564&scoped=true&"
import script from "./ServicesPricing.vue?vue&type=script&lang=js&"
export * from "./ServicesPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f8564",
  null
  
)

export default component.exports